import angular from 'angular';
import moment from "angular-moment";

import chartConfig from './power-stat-graph-active.config';

export class PowerStatGraphActiveController {
  /*@ngInject*/
  constructor($scope, $filter, $interval, moment) {
    this.$filter = $filter;
    this.$interval = $interval;
    this.moment = moment;

    this.WEEK = ['日', '月', '火', '水', '木', '金', '土'];

    this.chartConfig = chartConfig(this);
    $scope.$watch('$ctrl.data.dailyActivePower', newValue => this.updateGraph(newValue, this.data.targetDate));
    $scope.$watch('$ctrl.data.type', () => this.reflowGraph());
  }

  $onInit() {}

  updateGraph(dailyActivePowers) {
    if (!dailyActivePowers || !this.chart) {
      return;
    }

    const graphData = this.createGraphData(dailyActivePowers.current);

    this.chart.series[0].setData(graphData);
    this.chart.reflow();
  }

  reflowGraph() {
    if (!this.chart) {
      return;
    }
    this.$interval(() => {
      this.chart.redraw();
      this.chart.reflow();
    }, 500);
  }

  createGraphData(activePowers) {
    if (activePowers.length === 0) {
      return [0, 0, 0, 0, 0, 0, 0];
    }

    const weekAvgs = {};
    for(let day of this.WEEK) {
      weekAvgs[day] = {count: 0, sum: 0};
    }

    for(let power of activePowers) {
      const day = this.$filter('dayFilter')(power.date);
      weekAvgs[day].sum += power.value;
      weekAvgs[day].count += 1;
    }
    const graphData = [];
    for(let day of this.WEEK) {
      let avg = 0;
      if (weekAvgs[day].count > 0) {
        avg = weekAvgs[day].sum / weekAvgs[day].count;
      }
      graphData.push(parseFloat(this.$filter('number')(avg, 2).replace(/,/g, '')));
    }

    return graphData;
  }
}

export default angular.module('leptonApp.powerStatGraphActive', [moment])
  .component('powerStatGraphActive', {
    template: '<chart value="$ctrl.chartConfig"></chart>',
    controller: PowerStatGraphActiveController,
    bindings: {
      data: '='
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/power-stat-graph/active-power/power-stat-graph-active.component.js